import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';

import { ActionButton } from 'core/components/action-button';
import x from 'core/assets/svg/times.svg';
import useStyles from '../../system-status.styles';

// Public embed of the graph on https://app.datadoghq.com/dashboard/utg-xba-pfe. An embed is a snapshot of
// the graph when it was shared, so editing the dashboard doesn't change it: create a new embed and swap the token.
const iframeURL =
  'https://app.datadoghq.com/graph/embed?token=105a2e4d4d197867c280f01a2015b201eca507ca95a0d487cb32d6261da22929&height=300&width=600&legend=true';

function SystemStatusGraph({ graphOpen, onClose }) {
  const classes = useStyles();
  return (
    <Dialog maxWidth="lg" open={graphOpen}>
      <DialogContent>
        <iframe title="datadogGraph" src={iframeURL} width="600" height="300" frameBorder="0" />
        <ActionButton size="big" type="edit" icon={x} className={classes.closeButton} onClick={onClose} />
      </DialogContent>
    </Dialog>
  );
}

export default SystemStatusGraph;
